import { withMarkerDetails, WithMarkerDetailsProps } from './with-marker-details';
import { MapboxMarkerBase } from './mapbox-marker';

export { MapboxMarkerBase };
export type { MapboxMarkerBaseProps } from './mapbox-marker';

export const MapboxMarker = withMarkerDetails(MapboxMarkerBase);
export type MapboxMarkerProps = WithMarkerDetailsProps;
